import ANL_API from 'api/anl/v1'
import STATISTICS_API from 'api/statistics/account/v2'
import { startSubmit, stopSubmit } from 'redux-form'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractViolations from 'utils/extractViolations'
import { notificationShow } from 'modules/Notifications/actions'

function* fetch({ payload: { external_id } }) {
  try {
    const { response, error } = yield call(ANL_API.fetchHierarchy, {
      external_id,
    })

    if (error || !response?.data) {
      throw new Error(error.statusText)
    }

    if (response.data.length === 0) {
      yield put({
        type: 'STATISTICS/PROFILES_HIERARCHY_SET',
        payload: { cantGetHierarchy: true },
      })
    }

    yield put({
      type: 'STATISTICS/PROFILES_HIERARCHY_SET',
      payload: { hierarchy: response.data },
    })
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    yield put({
      type: 'STATISTICS/PROFILES_HIERARCHY_SET',
      payload: { cantGetHierarchy: true },
    })
    console.logXHR(error)
  }
}

function* addAccount({ payload }) {
  try {
    yield put(startSubmit('StatisticsAccountConnectForm'))
    const { error } = yield call(STATISTICS_API.add, payload)

    if (error) {
      throw error
    }
  } catch (error) {
    yield put(
      stopSubmit('StatisticsAccountConnectForm', extractViolations(error)),
    )
  } finally {
    yield put(stopSubmit('StatisticsAccountConnectForm'))
  }
}

export default function* Sagas() {
  yield takeLatest('STATISTICS/PROFILES_HIERARCHY_FETCH', fetch)
  yield takeLatest('STATISTICS/ACCOUNT_ADD', addAccount)
}
